export const PromoCodeReport = {
	name: 'Promo Codes Usage Report',
	route: 'report-promo-codes',
}

export const WebsiteAnalyticsReport = {
	name: 'Website Analytics Report',
	route: 'report-website-analytics',
}

export const Nada = null
